(function () {
  'use strict';

  // GAS Web App URL — デプロイ後にここを更新
  var GAS_WEB_APP_URL =
    'https://script.google.com/macros/s/AKfycbyhnudZO6BL4JNFa9PYC2DLGcQY7BhlPxP-0cz9lifBiPzwzDLHCsNAmoQK8BRHlKFG/exec';

  var overlay = null;
  var currentData = {};

  function createModal() {
    if (overlay) return;

    overlay = document.createElement('div');
    overlay.className = 'notify-me-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Notify Me');

    overlay.innerHTML =
      '<div class="notify-me-dialog">' +
      '<button type="button" class="notify-me-close" aria-label="Close">' +
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
      '</button>' +
      '<h3 class="notify-me-title">Notify Me When Available</h3>' +
      '<p class="notify-me-subtitle"></p>' +
      '<form class="notify-me-form" novalidate>' +
      '<input type="email" class="notify-me-input" placeholder="Enter your email address" required autocomplete="email">' +
      '<label class="notify-me-consent">' +
      '<input type="checkbox" class="notify-me-consent-checkbox">' +
      '<span>Also receive updates about new products and promotions</span>' +
      '</label>' +
      '<button type="submit" class="notify-me-submit">' +
      '<span class="notify-me-submit-text">Submit</span>' +
      '<span class="notify-me-spinner" aria-hidden="true"></span>' +
      '</button>' +
      '</form>' +
      '<div class="notify-me-message" aria-live="polite"></div>' +
      '</div>';

    document.body.appendChild(overlay);

    // Close handlers
    overlay.querySelector('.notify-me-close').addEventListener('click', close);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });

    overlay.querySelector('.notify-me-form').addEventListener('submit', handleSubmit);
  }

  function open(productId, productTitle, productHandle, state) {
    createModal();
    currentData = {
      productId: productId,
      productTitle: productTitle,
      productHandle: productHandle,
      state: state,
    };

    // US 配送再開の需要計測は文言が異なる（"available" ではなく "shipping resumes"）
    var title = overlay.querySelector('.notify-me-title');
    var subtitle = overlay.querySelector('.notify-me-subtitle');
    if (state === 'US Shipping Suspended') {
      title.textContent = 'Notify Me';
      subtitle.textContent =
        'We\'ll email you if we\'re able to resume shipping "' + productTitle + '" to the United States.';
    } else {
      title.textContent = 'Notify Me When Available';
      subtitle.textContent =
        'We will email you when "' + productTitle + '" becomes available.';
    }
    overlay.querySelector('.notify-me-input').value = '';
    overlay.querySelector('.notify-me-consent-checkbox').checked = false;
    overlay.querySelector('.notify-me-message').textContent = '';
    overlay.querySelector('.notify-me-message').className = 'notify-me-message';
    var submitBtn = overlay.querySelector('.notify-me-submit');
    submitBtn.disabled = false;
    submitBtn.removeAttribute('aria-busy');

    overlay.setAttribute('open', '');
    document.body.classList.add('overflow-hidden');

    if (typeof trapFocus === 'function') {
      trapFocus(overlay.querySelector('.notify-me-dialog'));
    }

    overlay.querySelector('.notify-me-input').focus();
  }

  function close() {
    if (!overlay || !overlay.hasAttribute('open')) return;
    overlay.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus();
    }
  }

  function handleSubmit(e) {
    e.preventDefault();

    var input = overlay.querySelector('.notify-me-input');
    var email = input.value.trim();
    var msg = overlay.querySelector('.notify-me-message');
    var submitBtn = overlay.querySelector('.notify-me-submit');

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      msg.textContent = 'Please enter a valid email address.';
      msg.className = 'notify-me-message notify-me-message--error';
      input.focus();
      return;
    }

    if (!GAS_WEB_APP_URL) {
      msg.textContent = 'Notification service is not configured yet.';
      msg.className = 'notify-me-message notify-me-message--error';
      return;
    }

    submitBtn.disabled = true;
    submitBtn.setAttribute('aria-busy', 'true');
    msg.textContent = '';

    // ★mode:'no-cors' を使わないこと。
    //   opaque レスポンスになると成否を判定できず、GAS 側が失敗していても常に成功表示になる
    //   ＝登録が無音で失われる（2026-07-31 是正・タスク notify-me-nocors-silent-loss）。
    //   Content-Type を text/plain のままにするのはプリフライトを起こさないため。
    //   GAS の /exec は 302 を返すが、302 とリダイレクト先の両方に
    //   access-control-allow-origin: * が付くのでブラウザから本文を読める（実測済み）。
    fetch(GAS_WEB_APP_URL, {
      method: 'POST',
      credentials: 'omit',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify({
        action: 'register',
        email: email,
        productId: String(currentData.productId),
        productTitle: currentData.productTitle,
        productHandle: currentData.productHandle,
        state: currentData.state,
        marketingConsent: overlay.querySelector('.notify-me-consent-checkbox').checked,
      }),
    })
      .then(function (res) {
        return res.text().then(function (text) {
          if (!res.ok) throw new Error('HTTP ' + res.status + ': ' + text.slice(0, 200));
          var data;
          try {
            data = JSON.parse(text);
          } catch (e) {
            // JSON でない＝GAS がHTMLエラーページ等を返した。成功扱いにしない。
            throw new Error('Unexpected response: ' + text.slice(0, 200));
          }
          // 'Already registered' も status:'ok'（重複登録は正常系）
          if (!data || data.status !== 'ok') {
            throw new Error('Registration rejected: ' + (data && data.message ? data.message : text.slice(0, 200)));
          }
          return data;
        });
      })
      .then(function () {
        msg.textContent = "You're all set! We'll notify you when this product is available.";
        msg.className = 'notify-me-message notify-me-message--success';
        setTimeout(close, 2500);
      })
      .catch(function (err) {
        console.error('[bpjp-notify-me] registration failed:', err);
        msg.textContent = 'Something went wrong. Please try again.';
        msg.className = 'notify-me-message notify-me-message--error';
        submitBtn.disabled = false;
        submitBtn.removeAttribute('aria-busy');
      });
  }

  // ESC key handler
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  // Click handler delegation for Notify Me buttons
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bpjp-notify-me]');
    if (!btn) return;
    e.preventDefault();
    open(btn.dataset.productId, btn.dataset.productTitle, btn.dataset.productHandle, btn.dataset.notifyState);
  });

  window.bpjpNotifyMe = { open: open, close: close };
})();
